import { fetchWrapper } from 'app/_helpers/fetch-wrapper';
import { Axios } from 'axios';
const WMSInbondURL = process.env.REACT_APP_API_WMSINBOUND_URL;
const baseUrl = `${WMSInbondURL}advice-details`;

const baseUrlbarcode = `${WMSInbondURL}generatebarcode`;

export const AdviceDetailsService = {
    getAll,
    getByAdviceId,
    getById,
    create,
    update,
    AdviceBarcodeByAdviceId,

    delete: _delete
};

function getAll() {
    return fetchWrapper.get(baseUrl);
}

function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function getByAdviceId(id) {
    return fetchWrapper.get(`${baseUrl}/advice-id?adviceId=${id}`);
}
function AdviceBarcodeByAdviceId(id) {
    return fetchWrapper.get(`${baseUrlbarcode}/adviceitem-id?adviceItemId=${id}`);
    //return Axios.get(`${baseUrlbarcode}/adviceitem-id?adviceItemId=${id}`);
}

function create(params, id) {
    return fetchWrapper.post(`${baseUrl}/bulk-upload?adviceId=${id}`, params);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}
